module.exports = __webpack_public_path__ + "img/QRCode_Android.75bdcce0.png";